/**
 * created by mleitzell on 12/20/17.
 */
import Base from "app/main/MainPopUpViewModel";
import ConcurrentLicenseDS from "common/datasources/license/ConcurrentLicenseDS";

export default Base.extend({

    // reference to the popup
    win: undefined,

    // datasource of concurrent logins
    logins: undefined,

    /**
     * init license ds to show user all concurrent licenses
     */
    onOpen: function() {
        this.set("logins", new ConcurrentLicenseDS());
        this.win().stallOpen(this.get("logins").read());
    }
});
